<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ID'), sort: 'ID' },
                { title: $t('OrderType'), sort: 'OrderType' },
                { title: $t('CustomerID'), sort: 'CustomerID' },
                { title: $t('CustomerName'), sort: 'CustomerName' },
                { title: $t('TadbirCreateOn'), sort: 'TadbirCreateOn' },
                { title: $t('OrderTimeOnSite'), sort: 'OrderTimeOnSite' },
                { title: $t('Action') }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width:10%">
                  {{ row.id }}
                </td>
                <td style="width:17%">
                  <span v-if="row.orderType == '0'">
                    {{ $t("Buy") }}
                  </span>
                  <span v-if="row.orderType == '1'">
                    {{ $t("Sale") }}
                  </span>
                  <span v-if="row.orderType == '2'">
                    {{ $t("BuyReturn") }}
                  </span>
                  <span v-if="row.orderType == '3'">
                    {{ $t("SaleReturn") }}
                  </span>
                  <span v-if="row.orderType == '4'">
                    {{ $t("DraftOrder") }}
                  </span>
                </td>
                <td style="width:10%">
                  {{ row.customerQuery.id }}
                </td>
                <td style="width:20%">
                  {{ row.customerQuery.customerName }}
                </td>
                <td class="ltr" style="width:15%">
                   {{ row.createOn.split(" ")[0] }}<br />{{
                  row.createOn.split(" ")[1]
                }}
                </td>
                <td class="ltr" style="width:15%">
                  {{ row.orderTimeOnSite }}
                </td>
                <td style="width:10%">
                  <router-link
                    :to="{ path: '/TadbirOrders/Details/' + row.id }"
                  >
                    <vs-button
                      radius
                      color="success"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="ml-4 d-inline"
                    ></vs-button>
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  components: {
    DataGrid
  },
  data() {
    return {
      ModifyPopup: false,
      modalModel: {},
      gridDataSource: {
        type: "app",
        service: "MiddlewareOfAccessToTadbir/api/OrdersQuery"
      },
      gridSearchData: {
        keyword: ""
      }
    };
  }
};
</script>
